import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import {AuthGuardService}from'./services/auth-guard.service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import * as firebase from 'firebase';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicSelectableModule } from 'ionic-selectable';
import { ChartsModule } from 'ng2-charts';
import 'chartjs-plugin-zoom';
import {ModalDatasetPageModule}from'./modal-dataset/modal-dataset.module'
import {ModalUploadPageModule}from'./modal-upload/modal-upload.module'


var config = {
  apiKey: "AIzaSyCJkt5_qUhdg8BFzq_HYBqyKT1Q9PIxM4s",
    authDomain: "gt-lab.firebaseapp.com",
    databaseURL: "https://gt-lab.firebaseio.com",
    projectId: "gt-lab",
    storageBucket: "gt-lab.appspot.com",
    messagingSenderId: "563944557238",
    appId: "1:563944557238:web:bb005bb2588add4ad63417"
};

firebase.initializeApp(config);

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,IonicSelectableModule,ChartsModule,ModalDatasetPageModule,ModalUploadPageModule],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
